module.exports = __webpack_public_path__ + "static/media/BlueSt.a7b615f6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Games/Sweeper/assets/BlueSt.gif
// module id = 129
// module chunks = 0